export default __webpack_public_path__ + "static/media/icon-cross.a3146d5e.svg";